import { useEffect } from 'react'
import { fetchTopStats } from '../../../effects'
import { useActivitySummaryContext } from '../../../context'
import type { ActivitySummaryFilterSet } from '../../../typings'
import { setActivitySummaryStatsLoadingActionCreator as setLoading } from '../../../state'

export function useData() {
  const [{ statsState, filterSet, activeTab }] = useActivitySummaryContext()

  useFetchData({
    filters: filterSet.filters,
    activeTab,
  })

  return { ...statsState }
}

function useFetchData(props: {
  filters: ActivitySummaryFilterSet['filters']
  activeTab: string
}) {
  const { filters, activeTab } = props
  const [, dispatch] = useActivitySummaryContext()

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      dispatch(setLoading(true))
      const response = await fetchTopStats(filters)
      if (mounted) {
        dispatch(response)
        dispatch(setLoading(false))
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, filters, activeTab])
}
